import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      //隔膜泵
      path: '/Diaphragm.html',
      name: 'home',
      component: () => import('@/views/home/diaphragmPump/index.vue')
    },
    {
      //软管泵
      path: '/Peristaltic.html',
      name: 'hosePump',
      component:  () => import('@/views/home/hosePump/index.vue'),
    },
    {
      //齿轮泵
      path: '/Gear.html',
      name: 'gearPump.html',
      component: () => import('@/views/home/gearPump/index.vue'),
    },
    {
      //螺旋泵
      path: '/ScrewCentrifugal.html',
      name: 'screwPump',
      component: () => import('@/views/home/screwPump/index.vue'),
    },
    {
      //离心泵
      path: '/SanitaryCentrifugal.html',
      name: 'centrifugalPump',
      component: () => import('@/views/home/centrifugalPump/index.vue')
    },
    {
      //蠕动泵
      path: '/OEMPeristaltic.html',
      name: 'peristalticPump',
      component: () => import('@/views/home/peristalticPump/index.vue')
    },
    {
      //转子泵
      path: '/Lobepump.html',
      name: 'rotorPump',
      component: () => import('@/views/home/rotorPump/index.vue')
    },
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};


// WEBPACK FOOTER //
// ./src/router/index.js